var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 生小孩h5选图页面
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TinyChooseImageArea from '../../lib/components/TinyChooseImageArea';
import { getBackendResult } from '../../lib/utils/fetch-data';
import { ERROR_CODE_MAPPING, generateCommonData } from '../H5ChristmasIndexPage/h5-config';
import { updateCurPageAction, updateFaceLocationInfo, updateVideoResultDownloadImageUrlAction, updateVideoResultUrlAction, } from '../../lib/common/store/reducer/actions';
import Modal from '../../lib/components/Modal';
import { setCropType, 
// setFatherCropImg,
// setMotherCropImg,
setFatherOriginImg, setMotherOriginImg, } from '../../lib/common/store/reducer/h5-baby';
import style from './index.module.scss';
// import MALE_PIC from './static/male.png';
// import FEMAL_PIC from './static/femal.png';
import { reportError } from '../../lib/utils/beacon';
import { NET_WORK_ERROR } from '../../lib/constant/network';
const DEFAULT_FEEDBACK_MSG = '当前体验人数较多, 请稍后再试吧~';
// TODO:
const demoResultVideoUrl = 'https://act-artifacts.shadowcv.qq.com/mqq/funny_video/res/a5fb3e78-bad2-11eb-bd67-525400c4b2f7.mp4';
const H5BabyChooseImagePage = ({ data: { fatherChooseIcon, motherChooseIcon, playBtnUrl, backgroundUrl, titleImgUrl, femalReselectImgUrl, maleReselectImgUrl, loadingImgUrl, faceRatio, tipImageUrl, }, global, }) => {
    const dispatch = useDispatch();
    const [fatherImage, setFatherImage] = useState('');
    const [motherImage, setMotherImage] = useState('');
    const [isShowErrorModal, setErrorModal] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState(DEFAULT_FEEDBACK_MSG);
    const [isShowLoading, setLoadingStatus] = useState(false);
    const fatherCropImage = useSelector(store => store.h5Baby.fatherCropImg);
    const motherCropImage = useSelector(store => store.h5Baby.motherCropImg);
    const isAutoDetectFace = useSelector(store => store.h5Baby.isAutoDetectFace);
    const commonData = generateCommonData(global);
    const selectedMaterial = useSelector(store => store.base.selectedMaterial);
    const maleCropRef = useRef(null);
    const femaleCropRef = useRef(null);
    useEffect(() => {
        setMotherImage(motherCropImage);
        setFatherImage(fatherCropImage);
    }, [fatherCropImage, motherCropImage]);
    const handleClickMake = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isAutoDetectFace) {
            yield handleClickAction(maleCropRef.current.getImageBase64(), femaleCropRef.current.getImageBase64());
            return;
        }
        yield handleClickAction();
    });
    const handleClickAction = (maleImage, femaleImage) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const maleCroppedImage = maleImage || fatherImage;
        const femaleCroppedImage = femaleImage || motherImage;
        if (maleCroppedImage && femaleCroppedImage) {
            setLoadingStatus(true);
            const imageBase64List = [maleCroppedImage.split(',')[1], femaleCroppedImage.split(',')[1]];
            // 后台请求
            try {
                const maleRes = getBackendResult(selectedMaterial, imageBase64List, commonData.apiUrl, {
                    // 默认是男性
                    gender: 'male',
                });
                const res = yield Promise.all([maleRes]);
                const isNetworkError = res.some(data => data.message === NET_WORK_ERROR);
                if (isNetworkError) {
                    throw new Error('网络错误，请检查网络!');
                }
                const isError = res.some(data => data.data.code !== 0);
                if (isError) {
                    const errorRes = res.find(data => data.data.code !== 0);
                    const errMsg = ERROR_CODE_MAPPING[errorRes.data.code]
                        ? ERROR_CODE_MAPPING[errorRes.data.code].msg
                        : '活动太火爆了，请稍后再试';
                    setFeedbackMsg(errMsg);
                    setErrorModal(true);
                    setLoadingStatus(false);
                    reportError({ errCode: errorRes.data.code, errMsg });
                    return;
                }
                const [maleData] = res;
                const extraInfo = JSON.parse(maleData.data.extra);
                // 更新store, 跳转结果页面
                dispatch(updateVideoResultDownloadImageUrlAction(extraInfo.img_urls[0]));
                dispatch(updateVideoResultUrlAction(((_a = extraInfo.video_urls) === null || _a === void 0 ? void 0 : _a[0]) || demoResultVideoUrl));
                dispatch(updateCurPageAction('result'));
                setLoadingStatus(false);
            }
            catch (err) {
                setFeedbackMsg(err.message);
                setErrorModal(true);
                setLoadingStatus(false);
                reportError({ errMsg: err.message });
            }
        }
        else {
            setFeedbackMsg('请选择照片');
            setErrorModal(true);
            reportError({ errMsg: '请选择照片' });
        }
    });
    const handleChooseImage = (img, type) => {
        if (type === 'male') {
            setFatherImage(img);
            dispatch(setCropType('father'));
            dispatch(setFatherOriginImg(img));
        }
        if (type === 'female') {
            setMotherImage(img);
            dispatch(setCropType('mother'));
            dispatch(setMotherOriginImg(img));
        }
        !isAutoDetectFace && dispatch(updateCurPageAction('crop'));
    };
    const modalContent = () => (React.createElement("div", { className: style['feedback-modal'] },
        React.createElement("div", { className: style['feedback-modal-title'] }, feedbackMsg),
        React.createElement("div", { className: style['feedback-modal-action-btn'], onClick: () => {
                setErrorModal(false);
            } }, "\u597D\u7684")));
    const loadingContent = () => (React.createElement("div", { className: style['loading-modal'] },
        React.createElement("img", { src: loadingImgUrl, alt: "" })));
    /**
     * 切换使用默认照片
     */
    // const handleDefaultBtnClick = () => {
    //   setFatherImage(MALE_PIC);
    //   setMotherImage(FEMAL_PIC);
    //   dispatch(setCropType('father'));
    //   dispatch(setFatherCropImg(MALE_PIC));
    //   dispatch(setMotherCropImg(FEMAL_PIC));
    // };
    const updateFaceInfo = (face) => {
        dispatch(updateFaceLocationInfo(face));
    };
    return (React.createElement("div", { className: style['choose-image-container'], style: { backgroundImage: `url(${backgroundUrl})` } },
        React.createElement("div", { className: style.title },
            React.createElement("img", { src: titleImgUrl, alt: "" })),
        React.createElement("div", { className: style['main-wrapper'] },
            React.createElement("div", { className: style.child },
                React.createElement(TinyChooseImageArea, { backgroundImage: fatherChooseIcon, chooseImageMask: maleReselectImgUrl, isAutoDetectFace: isAutoDetectFace, handleChooseImage: img => handleChooseImage(img, 'male'), outerImage: fatherImage, loadingUrl: loadingImgUrl, isCanbeDrag: isAutoDetectFace, ref: maleCropRef, faceAreaRatio: faceRatio, getFaceInfo: updateFaceInfo })),
            React.createElement("div", { className: style.child },
                React.createElement(TinyChooseImageArea, { backgroundImage: motherChooseIcon, chooseImageMask: femalReselectImgUrl, isAutoDetectFace: isAutoDetectFace, handleChooseImage: img => handleChooseImage(img, 'female'), outerImage: motherImage, loadingUrl: loadingImgUrl, isCanbeDrag: isAutoDetectFace, ref: femaleCropRef, faceAreaRatio: faceRatio, getFaceInfo: updateFaceInfo }))),
        React.createElement("div", { className: style.tip },
            React.createElement("img", { src: tipImageUrl, alt: "" })),
        React.createElement("div", { className: style.btn },
            React.createElement("img", { src: playBtnUrl, alt: "alt", onClick: handleClickMake, "data-btn-id": "choose_image#submit" })),
        React.createElement(Modal, { content: modalContent(), visible: isShowErrorModal, hideModal: () => setErrorModal(false) }),
        React.createElement(Modal, { content: loadingContent(), visible: isShowLoading, isClosedByClick: false, hideModal: () => setLoadingStatus(false) })));
};
export default H5BabyChooseImagePage;
